// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"49ba8b68","113":"da164af0","204":"570f997c","264":"64f6821e","434":"5ecfe194","453":"86ac57da","818":"7653f169","922":"116ce8ec"}[chunkId] + ".chunk.js";
};